import { $t } from '@teachino/shared-i18n';
import { computed, ref, type Ref } from 'vue';

export class ChunkedHttpRequestHandler {
  private _stream: Ref<string> = ref('');
  private _isStreaming = ref(false);

  public stream = computed(() => this._stream.value);
  public isStreaming = computed(() => this._isStreaming.value);

  public handleRequest(request: Promise<Response>): Promise<void> {
    this._stream.value = '';
    this._isStreaming.value = true;
    const done = new Promise<void>((resolve) => {
      request
        .then(async (response) => {
          this._isStreaming.value = true;
          const reader = response.body?.getReader();
          const decoder = new TextDecoder('utf-8');

          if (reader) {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while (true) {
              const { value, done: streamDone } = await reader.read();

              if (streamDone) {
                this._isStreaming.value = false;
                resolve();
                return;
              }
              const decoded = decoder.decode(value);
              this._stream.value = this._stream.value.concat(decoded);
            }
          }
        })
        .catch((error: unknown) => {
          console.error('Stream Failed');
          console.error(error);

          if (error instanceof DOMException) {
            return this._stream;
          }

          this._stream.value = `${this._stream.value} <error><message>${$t('generic_error')}</message></error>`;
          this._isStreaming.value = false;
          return this._stream;
        });
    });
    return done;
  }
}
